import { ALL_RARITIES } from '../../hooks/usePersistentProgress';

const RARITY_LABELS = {
  common:    { label: 'Common',    color: '#9e9e9e' },
  uncommon:  { label: 'Uncommon',  color: '#4caf50' },
  rare:      { label: 'Rare',      color: '#2196f3' },
  epic:      { label: 'Epic',      color: '#9c27b0' },
  legendary: { label: 'Legendary', color: '#ff9800' },
};

/**
 * Settings overlay — floats above any screen (idle or paused game world).
 * Props: musicVolume, musicMuted, onVolumeChange, onMuteToggle,
 *        lootFilter, onLootFilterChange, onClose
 */
export function SettingsScreen({
  musicVolume, musicMuted, onVolumeChange, onMuteToggle,
  lootFilter, onLootFilterChange,
  onClose,
}) {
  const activeFilter = lootFilter ?? ALL_RARITIES;

  function toggleRarity(rarity) {
    const isOn = activeFilter.includes(rarity);
    if (isOn && activeFilter.length === 1) return; // keep at least one enabled
    const next = isOn
      ? activeFilter.filter(r => r !== rarity)
      : [...activeFilter, rarity];
    onLootFilterChange(next);
  }

  return (
    <div className="settings-backdrop" onClick={onClose}>
      <div className="settings-panel" onClick={e => e.stopPropagation()}>
        <h2 className="settings-title">⚙️ Settings</h2>

        {/* ── Music ─────────────────────────────────────────────────── */}
        <section className="settings-section">
          <h3 className="settings-section-heading">Music</h3>

          <div className="settings-row">
            <span className="settings-label">Background music</span>
            <button
              className={`settings-toggle${musicMuted ? ' settings-toggle--off' : ''}`}
              onClick={onMuteToggle}
              aria-label={musicMuted ? 'Unmute music' : 'Mute music'}
            >
              {musicMuted ? '🔇 Muted' : '🔊 On'}
            </button>
          </div>

          <div className="settings-row">
            <span className="settings-label">Volume</span>
            <div className="settings-volume-wrap">
              <input
                type="range"
                min="0" max="1" step="0.01"
                value={musicMuted ? 0 : musicVolume}
                onChange={e => onVolumeChange(parseFloat(e.target.value))}
                className="settings-volume-slider"
                aria-label="Music volume"
              />
              <span className="settings-volume-pct">
                {musicMuted ? '0' : Math.round(musicVolume * 100)}%
              </span>
            </div>
          </div>
        </section>

        {/* ── Loot Filter ───────────────────────────────────────────── */}
        <section className="settings-section">
          <h3 className="settings-section-heading">Loot Filter</h3>
          <p className="settings-loot-hint">Choose which item rarities drop during a run. XP always drops.</p>
          <div className="settings-loot-filter">
            {ALL_RARITIES.map(rarity => {
              const { label, color } = RARITY_LABELS[rarity];
              const active = activeFilter.includes(rarity);
              return (
                <button
                  key={rarity}
                  className={`settings-rarity-btn${active ? ' settings-rarity-btn--on' : ''}`}
                  style={{ '--rarity-color': color }}
                  onClick={() => toggleRarity(rarity)}
                  aria-pressed={active}
                >
                  {label}
                </button>
              );
            })}
          </div>
        </section>

        <button className="settings-close-btn" onClick={onClose}>✕ Close</button>
      </div>
    </div>
  );
}
